import "./HireSeoConsultant.module.css";
import Header from "@/reusable_sections/Header";
import HireConsultant from "./sections/HireConsultant";
import WhenToHire from "./sections/WhenToHire";
import Consulting from "./sections/Consulting";
import Process from "./sections/Process";
import Collaboration from "./sections/Collaboration";
import Consultantfaq from "./sections/Consultantfaq";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function HireSeoConsultantPage() {
  return <div>
      <Header />
      <HireConsultant />
      <WhenToHire />
      <Consulting />
      <Process />
      <Collaboration />
      <Consultantfaq />
      <Consultation />
      <Footer />
    </div>;
}